import { useState, type ReactElement } from "react";
import { GroupUserSection } from "../../_components/group-user-section";
import { UserFilter, useGroupUsers } from "../../_hooks/use-group-users";
import { useResponsivePageSize } from "../../_hooks/use-responsive-page-size";

export function UsersTab({ groupUuid, canManage }: { groupUuid: string; canManage: boolean }): ReactElement {
  const [userSearchTerm, setUserSearchTerm] = useState("");
  const [userFilter, setUserFilter] = useState<UserFilter>(UserFilter.All);

  const { filteredUsers, userStats, isLoading } = useGroupUsers(groupUuid, userSearchTerm, userFilter);
  const { paginationState, handlePaginationChange } = useResponsivePageSize(filteredUsers.length);

  return (
    <GroupUserSection
      groupUuid={groupUuid}
      canManage={canManage}
      filteredUsers={filteredUsers}
      userFilter={userFilter}
      onUserFilterChange={setUserFilter}
      userSearchTerm={userSearchTerm}
      onSearchChange={setUserSearchTerm}
      userStats={userStats}
      isLoading={isLoading}
      paginationState={paginationState}
      onPaginationChange={handlePaginationChange}
    />
  );
}
